// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"z-","cross":"z_","iconSVGWrapper":"Aa","iconSVG":"Ab","iconSVGDark":"Ac"};